import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/css/customer/services/ServicesCardsSection.css';

const ServicesCardsSection = () => {
  const services = [
    {
      id: 1,
      title: 'Wedding Planning',
      imageUrl: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=600&h=400&fit=crop',
      description: 'lobortis non recusandae libero eiua eni rerum hic tenetur a sapiente dolore qui recusandae voluptatibus maxima alias consequatur aut Molestiae non...'
    },
    {
      id: 2,
      title: 'Corporate Events',
      imageUrl: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=600&h=400&fit=crop',
      description: 'lobortis non recusandae libero eiua eni rerum hic tenetur a sapiente dolore qui recusandae voluptatibus maxima alias consequatur aut Molestiae non...'
    },
    {
      id: 3,
      title: 'Social Gatherings',
      imageUrl: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=600&h=400&fit=crop',
      description: 'lobortis non recusandae libero eiua eni rerum hic tenetur a sapiente dolore qui recusandae voluptatibus maxima alias consequatur aut Molestiae non...'
    }
  ];

  return (
    <section className="scs-services-cards-section">
      {/* Decorative Circle Top Right */}
      <div className="scs-decorative-circle-top">
        <svg width="150" height="150" viewBox="0 0 150 150">
          <circle cx="75" cy="75" r="60" fill="none" stroke="#ffd4d4" strokeWidth="2" opacity="0.4"/>
          <circle cx="100" cy="50" r="8" fill="#f8b4b4" opacity="0.6"/>
        </svg>
      </div>

      <Container>
        {/* Section Header */}
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8} md={10} xs={12}>
            <p className="scs-section-label">Bridely Services</p>
            <h2 className="scs-section-heading">
              Bringing Your Dream<br/>
              Event to Life
            </h2>
          </Col>
        </Row>

        {/* Services Cards */}
        <Row className="g-4 justify-content-center">
          {services.map((service, index) => (
            <Col 
              key={service.id}
              lg={4}
              md={6}
              sm={12}
              className="scs-service-card-col"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <Card className="scs-service-card h-100">
                <div className="scs-card-image-wrapper">
                  <Card.Img 
                    variant="top" 
                    src={service.imageUrl}
                    alt={service.title}
                    className="scs-card-image"
                  />
                </div>
                <Card.Body className="scs-card-body">
                  <Card.Title className="scs-service-title">
                    {service.title}
                  </Card.Title>
                  <Card.Text className="scs-service-description">
                    {service.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Decorative Circle Bottom Left */}
      <div className="scs-decorative-circle-bottom">
        <svg width="120" height="120" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="50" fill="#ffd4d4" opacity="0.2"/>
          <circle cx="60" cy="60" r="35" fill="#ffb0b0" opacity="0.3"/>
        </svg>
      </div>
    </section>
  );
};

export default ServicesCardsSection;